import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import ErrorFeedback from './ErrorFeedback';
import SuccessFeedback from './SuccessFeedback';

import Box from '../../Atomics/Box';
import { Container } from '../../Atomics/Container';
import { Modal, ModalHeader } from '../../Atomics/Modal';
import NovaCircle from '../../Atomics/NovaCircle';
import LoadingNova from '../../Atomics/LoadingNova';

import { useTranslationContext } from '../../../../contexts/TranslationContext';
import lockScrollbar from '../../../../utils/helpers/lockScrollbar';

type TProps = {
    step?: number;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    successTitle?: string;
    successDescription?: string;
    errorDescription?: string;
    onErrorCTA: React.MouseEventHandler<HTMLButtonElement>;
};

const StyledMiddleBox = styled(Box)`
    position: absolute;
    width: 100%;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
`;

const FeedbackPage = ({ step, isLoading, isError, isSuccess, successTitle, successDescription, errorDescription, onErrorCTA }: TProps) => {
    const { resources } = useTranslationContext();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(true);

    const handleCloseModal = () => {
        setIsOpen(false);
        navigate(-1);
    };

    const renderFeedback = () => {
        if (isError) {
            return (
                <StyledMiddleBox>
                    <Container>
                        <ErrorFeedback
                            title={resources.feedback.errorTitle}
                            description={errorDescription ? errorDescription : resources.feedback.report.errorDescription1}
                            ctaText={resources.label.tryAgain}
                            onClick={(e) => { onErrorCTA(e); setIsOpen(false); lockScrollbar(false) }}

                        />
                    </Container>
                </StyledMiddleBox>
            );
        }

        if (isSuccess) {
            return (
                <StyledMiddleBox>
                    <Container>
                        <SuccessFeedback
                            title={successTitle ? successTitle : resources.feedback.report.successTitle}
                            description={successDescription ? successDescription : resources.feedback.report.successDescription1}
                        />
                    </Container>
                </StyledMiddleBox>
            );
        }

        if (isLoading) {
            return (
                <StyledMiddleBox textAlign='center'>
                    <LoadingNova />
                </StyledMiddleBox>
            );
        }
    };

    // Loading
    return (
        <Modal show={isOpen} onClose={handleCloseModal} fullScreen>
            {(
                <>
                    <ModalHeader onClose={handleCloseModal} />
                    <NovaCircle size={158} customPosition="top-right" zIndex={1000} customColor="neutral0.5" />
                </>
            )}
            {renderFeedback()}
        </Modal>
    );
};

export default FeedbackPage;
